import { render, staticRenderFns } from "./Product2.vue?vue&type=template&id=dab5f034&scoped=true"
import script from "./Product2.vue?vue&type=script&lang=js"
export * from "./Product2.vue?vue&type=script&lang=js"
import style0 from "./Product2.vue?vue&type=style&index=0&id=dab5f034&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab5f034",
  null
  
)

export default component.exports